import { render } from "./ReceiptList.vue?vue&type=template&id=5df0aeb2&ts=true"
import script from "./ReceiptList.vue?vue&type=script&lang=ts"
export * from "./ReceiptList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__